/**
 * KAN-840: часовой пояс организации текущего пользователя (organization_timezone
 * из /auth/me, общий кеш ['currentUser']). Пока ответа нет или поле пустое: Москва.
 */
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { resolveTimezone } from '@/lib/orgTimezone';

export function useOrgTimezone(): string {
  // Моки useCurrentUser в тестах иногда отдают undefined: тогда Москва.
  const data = useCurrentUser()?.data;
  return resolveTimezone(data?.organization_timezone);
}
